import { useSelector } from 'react-redux';
import { Store } from '@mui/icons-material';

const MobileConfirmation = ({ component, data }) => {
    const { image_base_url: imageBaseUrl } = useSelector(state => state.config);

    const renderDetails = () =>
        data?.details?.map(({ label, value, isMerchant = false, icon = null }) => (
            <div key={label} className="border-t !border-input-border pt-2 mt-3">
                {isMerchant ? (
                    <CurrencyContainer
                        label={label}
                        imageBaseUrl={imageBaseUrl}
                        icon={icon}
                        heading={value}
                        isMerchant
                    />
                ) : (
                    <DetailContainer label={label} value={value} />
                )}
            </div>
        ));

    const renderAttachments = () => (
        <div className="border-t !border-input-border pt-2 mt-3">
            <DetailContainer
                label="Attachments"
                value={
                    <>
                        {data?.attachments?.map(({ label, value }) => (
                            <AttachmentContainer key={label} label={label} value={value} />
                        ))}
                    </>
                }
            />
        </div>
    );

    return (
        <div className="w-full max-w-md mb-2">
            <div className="space-y-2">
                <h2 className="text-xs font-medium text-balanceCard-manage uppercase mb-2">
                    {data?.title}
                </h2>
                <CurrencyContainer
                    imageBaseUrl={imageBaseUrl}
                    icon={data?.currencyIcon}
                    heading={data?.amount}
                />
                <p className="text-xs text-balanceCard-manage">BALANCE: {data?.balance}</p>
            </div>

            {component === 'fx' && (
                <div className="border-t !border-input-border pt-3 mt-3">
                    <h2 className="text-xs font-medium text-balanceCard-manage uppercase mb-2">
                        {data?.toTitle}
                    </h2>
                    <CurrencyContainer
                        imageBaseUrl={imageBaseUrl}
                        icon={data?.toCurrencyIcon}
                        heading={data?.toAmount}
                    />
                    <p className="text-xs text-balanceCard-manage mt-2">
                        BALANCE: {data?.toBalance}
                    </p>
                </div>
            )}

            {renderDetails()}

            {data?.attachments?.length > 0 && renderAttachments()}
        </div>
    );
};

const CurrencyContainer = ({ imageBaseUrl, icon, heading, label, isMerchant = false }) => (
    <>
       {isMerchant && <p className="text-xs font-medium text-balanceCard-manage uppercase pt-1 pb-1">{label}</p>}
        <div className="flex items-center">
            {icon ? (
                <img src={`${imageBaseUrl}${icon}`} width={24} height={24} alt="currencyIcon" />
            ) : (
                isMerchant && <Store fontSize="medium" className="!text-primary" />
            )}
            <span className="text-base font-medium !text-text pl-2">{heading}</span>
        </div>
    </>
);

const DetailContainer = ({ label, value }) => (
    <>
        <p className="text-xs font-medium text-balanceCard-manage uppercase py-1">{label}</p>
        <p className="text-base font-medium !text-text uppercase">{value}</p>
    </>
);

const AttachmentContainer = ({ label, value }) => (
    <div className="rounded-md border border-[#D1D1D6] p-3.5 px-4 grid grid-cols-[1fr_auto] gap-2.5 items-center mt-3 dark:border-[#51525C]">
        <div className="text-text uppercase text-sm">
            <span>{label}</span>
            <span className="block">{value}</span>
        </div>
    </div>
);

export default MobileConfirmation;
